// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3HBw2","left":"StickyBox_left__3VasO","right":"StickyBox_right__3FceZ"};